import { numFormatter } from '../utils/formatterUtils';

const CalculationsCard = ({ hoveredData }) => {

    return (
        <div className="card">
            <div className="card-content">
                <span style={{ fontWeight: "bold"}} className="card-title">{hoveredData.label[0]} {hoveredData.label[1]}</span>
                <div className='divider black'/>
                <p style={{ margin: '5px 0 5px 0', fontWeight:'bold'}}>
                    <i style={{ color: 'orange', verticalAlign: 'middle', marginRight: '5px'}} className="material-icons tiny">stop</i>
                    Index: {numFormatter(hoveredData.indexRate,'%',true)} / {numFormatter(hoveredData.indexValue,'$')}
                </p>
                <p style={{ margin: '5px 0 5px 0', fontWeight:'bold'}}>
                    <i style={{ color: 'blue', verticalAlign: 'middle', marginRight: '5px'}} className="material-icons tiny">stop</i>
                    Segment: {numFormatter(hoveredData.segmentRate,'%',true)} / {numFormatter(hoveredData.segmentValue,'$')}
                </p>
                <div className='divider black'/>
                <p style={{ margin: '5px 0 5px 0', fontWeight:'bold'}}>
                    Delta: {numFormatter(hoveredData.segmentRate.sub(hoveredData.indexRate),'%',true)} / 
                        {numFormatter(hoveredData.segmentValue.sub(hoveredData.indexValue),'$',true)}
                </p>
            </div>
        </div>
    )
};

export default CalculationsCard;